<nz-table #assetTable nzShowSizeChanger [nzLoading]="isLoading"
[nzScroll]="{ x: '1024px', y: '55dvh' }" [nzSize]="'small'" [nzPaginationType]="'small'"
[nzShowTotal]="totalTemplate">
  <thead>
    <tr>
      <th nzWidth="50%">Assets</th>
      <th nzWidth="50%">Location</th>
      <th nzWidth="50%">Location ID</th>
      <th nzWidth="50%">Incident</th>
      <th nzWidth="50%">Current Alarms</th>
      <th nzWidth="50%">Severity</th>
      <th nzWidth="50%">Triggered Time</th>
      <th nzWidth="50%">Status</th>
      <th nzWidth="50%">Assigned To</th>
    </tr>
  </thead>
  <tbody>



  </tbody>
  </nz-table>
  <ng-template #totalTemplate let-total>Showing {{ total }} items</ng-template>
